import {Worker, array_remove} from "../util";
import angular from "angular";

export default class RoleCtrl{
  constructor(UzivatelService, $q){
    this.UzivatelService = UzivatelService;    
    this.$q = $q;

    this.role = [];
    this.permissions = {};

    this.load = Worker(this._load);
    this.save = Worker(this._save);
    this.add = Worker(this._add);
    this.remove = Worker(this._remove);
    this.load();

  }

  _load(){
    return this.$q.all([
      this.UzivatelService.listPermissions().then(perms => this.permissions = perms),
      this.UzivatelService.listRole().then(roles => this.populateRoles(roles))
    ])
  }


  populateRoles(roles){
    var permissionsToMap = function(perms){
      var o = {};
      perms.forEach(perm => o[perm] = true);
      return o;
    }

    this.role = roles.map(rola => {
      return {
        id: rola.id,
        nazov: rola.nazov,
        permission_map: permissionsToMap(rola.permissions)
      }
    });
  }


  _add(name){
    return this.UzivatelService.saveRole([{nazov: name, permissions: []}]).then(role => this.populateRoles(role))
  }

  _remove(item){
    return this.UzivatelService.removeRola(item.id).then(x => array_remove(this.role, item), err => item.error = err)
  }

  _save(){
    var mapToPermissions = function(permMap){
      var l = [];
      angular.forEach(permMap, (enabled, key) => {
        console.log(enabled, key);
        if(enabled) l.push(key);
      });
      return l;
    }
    return this.UzivatelService.saveRole(
      this.role.map(rola => ({id: rola.id, nazov: rola.nazov, permissions: mapToPermissions(rola.permission_map)}))
    ).then(role => this.populateRoles(role));
  }

}


// WEBPACK FOOTER //
// ./src/Uzivatel/UzivatelRoleCtrl.js